import { Apis, Labels } from '../../app.constants';
import SweetAlert from '../../../components/Shared/Notification';
import APIService from '../../../Services/APIService';
import {
  alertAtom,
  orderListObjAtom,
  productListObjAtom,
  userInformationAtom,
} from '../../_states';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';

const TemplateActions = () => {
  const loggedInUserInfo = useRecoilValue(userInformationAtom);

  const getTemplateList = async (filters) => {
    filters.botNumber = filters?.botNumber || '';
    let res = await APIService.get(
      `${Apis.getTemplateList}?next_page=${filters?.page}&search=${filters?.search}&bot_number=${filters?.botNumber}`
    );
    if (res.status == 200) return res;
    else SweetAlert(Labels.Error, 'error');
  };

  const sendTemplate = async (data) => {
    let res = await APIService.post(`${Apis.sendTemplate}?bot_number=${data[0]?.botNumber}`, data);
    if (res?.data?.status) SweetAlert(res?.data?.data, 'success');
    else SweetAlert('Failed to Send Template', 'error');
  };

  const getWhatsappTemplateList = async (data) => {
    let res = await APIService.get(
      `${Apis.getWhatsappTemplate}?next_page=${data?.page + 1}&search=${data?.search}&sort_field=${data?.sortField}&sort_order=${data?.sortOrder}&category=${data?.category}&bot_number=${data?.botNumber}&limit=${data?.limit || 10}&company_id=${data?.organisation || ''}&status=${data?.status || ''}`
    );
    if (res?.status === 200) {
      return res?.data;
    } else SweetAlert('Failed to fetch templates', 'error');
  };

  const postWhatsappTemplate = async (data, filters) => {
    let res = await APIService.post(
      `${Apis.whatsappTemplate}?bot_number=${filters?.botNumber}`,
      data
    );
    return res;
  };
  const updateWhatsappTemplate = async (data) => {
    let res = await APIService.put(`${Apis.whatsappTemplate}?bot_number=${data?.bot_number}`, data);
    return res;
  };

  const deleteWhatsappTemplate = async (name, data) => {
    let res = await APIService.remove(
      `${Apis.whatsappTemplate}?bot_number=${data?.bot_number || ''}&name=${name}`
    );
    return res;
  };
  const getTemplateByNameAndBotNumber = async (templateName, botNumber) => {
    let res = await APIService.get(
      `${Apis.whatsappTemplate}?bot_number=${botNumber || ''}&name=${templateName || ''}`
    );
    return res;
  };

  const sendWhatsappTemplate = async (data, filters) => {
    let res = await APIService.post(`${Apis.sendWhatsappTemplate}${filters?.bot_number}`, data);
    return res;
  };

  const uploadUserData = async (data, filters, onUploadProgress) => {
    let res = await APIService.uploadFile(
      `${Apis.uploadUserData}?bot_number=${filters?.bot_number || ''}&id=${filters?.wa_Id}`,
      data,
      onUploadProgress
    );
    return res;
  };

  const uploadHeaderFile = async (formdata, filters) => {
    let res = await APIService.post(
      `${Apis.uploadHeaderFile}?bot_number=${filters?.botNumber}`,
      formdata,
      {
        'Content-Type': 'multipart/form-data',
      }
    );
    return res;
  };

  // const uploadHeaderWhatsapp = async (formdata, filters) => {
  //   let res = await APIService.post(`${Apis.uploadHeaderWhatsapp}?bot_number=${filters?.botNumber}`, formdata, {
  //     'Content-Type': 'multipart/form-data',
  //   });
  //   return res;
  // }

  const getTemplateDateWiseSummary = async (data) => {
    let res = await APIService.get(
      `${Apis.getTemplateDateWiseSumnary}?template_id=${data?.template_id}&start_date=${data?.start_date}&end_date=${data?.end_date}&next_page=${data?.page || 0}&sort_by=${data?.sort_by}&order=${data?.order}&limit=${data?.limit}`
    );
    if (res?.status === 200) {
      return res?.data;
    } else SweetAlert('Failed to fetch templates', 'error');
  };

  const getTemplateUserSummary = async (data) => {
    let res = await APIService.get(
      `${Apis.getTemplateUserSummary}?template_id=${data?.templateId}&date=${data?.sentDate}&next_page=${data?.page}&search=${data?.search}&status=${data?.status}&assigned_to=${data?.assigned_to}&sort_by=${data?.sortField}&order=${data?.sortOrder}&limit=${data?.limit}&template_status=${data?.template_status}`
    );
    if (res?.status === 200) {
      return res?.data;
    } else SweetAlert('Failed to fetch templates', 'error');
  };

  const updateTemplateCallStatus = async (data) => {
    let res = await APIService.post(`${Apis.updateTemplateCallStatus}`, data);
    if (res?.status === 200) {
      // SweetAlert(res?.data?.data, 'success');
    }
    // else SweetAlert('Failed to update status', 'error');
  };

  const postTemplateUserComment = async (data) => {
    let res = await APIService.post(`${Apis.postTemplateUserComment}`, data);
    if (res?.status === 200) {
      SweetAlert(res?.data?.data, 'success');
      return res?.data;
    } else SweetAlert('Failed to add comment', 'error');
  };

  const sendTemplateCron = async (templateId) => {
    try {
      let res = await APIService.post(`${Apis.sendTemplateCron}?template_id=${templateId}`);
      return res;
    } catch (error) {
      return error;
    }
  };
  const getAllTemplates = async ({ organisation_id, bot_number }) => {
    try {
      const res = await APIService.get(
        `${Apis.getWhatsappTemplate}?company_id=${organisation_id}&bot_number=${bot_number}&limit=500`
      );
      if (res?.status === 200) {
        return res?.data?.data || [];
      } else {
        // SweetAlert('Failed to fetch all templates', 'error');
      }
    } catch (error) {
      // SweetAlert('Something went wrong while fetching templates', 'error');
      throw error;
    }
  };

  const getAllWabaAccounts = async () => {
    try {
      const res = await APIService.get(Apis.getWhatsappBusinessInfo);
      if (res?.status === 200) {
        return res?.data;
      } else {
        // SweetAlert('Failed to fetch WhatsApp Business accounts', 'error');
      }
    } catch (error) {
      // SweetAlert('Something went wrong while fetching WABA accounts', 'error');
      throw error;
    }
  };

  const registerWhatsappWebhook = async (data) => {
    try {
      const res = await APIService.post(Apis.registerWhatsappWebhook, data, {
        'Content-Type': 'application/json',
      });

      if (res?.status === 200) {
        // SweetAlert('Webhook registered successfully', 'success');
        return res?.data;
      } else {
        // SweetAlert('Failed to register webhook', 'error');
      }
    } catch (error) {
      // SweetAlert('Error while registering webhook', 'error');
      throw error;
    }
  };

  const getOptinList = async () => {
    try {
      const res = await APIService.get(`${Apis.getOptinList}`);
      if (res?.status === 200) {
        return res?.data;
      } else {
        // SweetAlert('Failed to fetch opt-in list', 'error');
      }
    } catch (error) {
      // SweetAlert('Something went wrong while fetching opt-in list', 'error');
      throw error;
    }
  };

  const downloadOptinList = async () => {
    try {
      await APIService.downloadFile(Apis.optinDownload, `Optin_Users_${Date.now()}.xlsx`);
    } catch (error) {
      // SweetAlert('Failed to download opt-in list', 'error');
      throw error;
    }
  };

  const optoutUser = async (phoneNumber) => {
    try {
      if (!phoneNumber) throw new Error('Phone number is required');
      const cleaned = String(phoneNumber).trim().replace(/^\+/, '').replace(/\s+/g, '');
      const res = await APIService.post(
        `${Apis.optoutUser}?phone_number=${encodeURIComponent(cleaned)}`,
        { phone_number: cleaned }
      );
      return res?.data;
    } catch (error) {
      throw error;
    }
  };

  return {
    getTemplateList,
    sendTemplate,
    getWhatsappTemplateList,
    postWhatsappTemplate,
    getTemplateByNameAndBotNumber,
    deleteWhatsappTemplate,
    updateWhatsappTemplate,
    sendWhatsappTemplate,
    uploadUserData,
    uploadHeaderFile,
    // uploadHeaderWhatsapp,
    getTemplateDateWiseSummary,
    getTemplateUserSummary,
    updateTemplateCallStatus,
    postTemplateUserComment,
    sendTemplateCron,
    getAllTemplates,
    getAllWabaAccounts,
    registerWhatsappWebhook,
    getOptinList,
    downloadOptinList,
    optoutUser,
  };
};

export { TemplateActions };
